// TODO add unit tests

const normalise = (url = '') => url.replace(/https?:\/\/[^/]+/, '')

export default normalise
